export function formatCPFCNPJ(value: string) {
  let cpfcnpj = value.replace(/\D/g, '');

  if (cpfcnpj.length === 14) {
    cpfcnpj = cpfcnpj.replace(/^(\d{2})(\d)/, '$1.$2');
    cpfcnpj = cpfcnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
    cpfcnpj = cpfcnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
    cpfcnpj = cpfcnpj.replace(/(\d{4})(\d)/, '$1-$2');

    return cpfcnpj;
  }
  const zerosFaltantes = 11 - cpfcnpj.length;

  if (zerosFaltantes > 0) {
    cpfcnpj = '0'.repeat(zerosFaltantes) + cpfcnpj;
  }
  if (cpfcnpj.length > 11 && cpfcnpj.length < 14) {
    cpfcnpj = cpfcnpj.replace(/^0+/, '');
  }

  cpfcnpj = cpfcnpj.replace(/(\d{3})(\d)/, '$1.$2');
  cpfcnpj = cpfcnpj.replace(/(\d{3})(\d)/, '$1.$2');
  cpfcnpj = cpfcnpj.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

  return cpfcnpj;
}
